import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

import { extractDate } from "../../../Components/Functions/date.fun";
const tableHead = [
  "Sr.",
  "Date",
  // "Time",
  "full name",
  "lead owner",
  "notes",
  "lead status",
  "Actions",
];

function convertTo12HourFormat(dateString) {
  const date = new Date(dateString);

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert 24-hour format to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // Hour '0' should be '12'

  // Format minutes to always be two digits
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

  return `${hours}:${formattedMinutes} ${ampm}`;
}
const AllLeadsTable = ({ leads = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/leads/view-lead/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {leads?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;

            return (
              <tr
                key={item?.id}
                // className="bg-purple-lt"
                className={item?.leadTransferTo ? "bg-purple-lt" : ""}
              >
                <td className={item?.leadTransferTo ? "text-black" : ""}>
                  {Index}
                </td>
                <td className={item?.leadTransferTo ? "text-black" : ""}>
                  {extractDate(item?.createdAt) || "N/A"}
                  <br />
                  {convertTo12HourFormat(item?.createdAt) || "N/A"}
                </td>
                {/* <td>{</td> */}
                {/* <td style={{ maxWidth: "200px" }}>
                  <span
                    className="cursor-pointer text-blue text-decoration-underline"
                    onClick={() => goToView(item.id)}
                  >
                    {item?.full_name || "N/A"}
                  </span>
                </td> */}
                <td className={item?.leadTransferTo ? "text-black" : ""}>
                  {item?.full_name || "N/A"} <br />{" "}
                  <span className="text-secondary badge bg-cyan-lt">
                    {item?.phone_number || "N/A"}
                  </span>
                </td>
                {/* <td>{item?.phone_number || "N/A"}</td> */}
                <td className={item?.leadTransferTo ? "text-black" : ""}>
                  {item?.lead_alloted_to || "N/A"}
                </td>

                <td
                  className={item?.leadTransferTo ? "text-black" : ""}
                  style={{ maxWidth: "200px" }}
                >
                  {item?.notes || "N/A"}
                </td>
                <td className={item?.leadTransferTo ? "text-black" : ""}>
                  {item?.lead_status || "N/A"}
                </td>

                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllLeadsTable;
